export default __webpack_public_path__ + "static/media/avatar15.b9b5a72e.png";